import { createFileRoute } from "@tanstack/react-router";

import { NewEventDialog } from "../features/events/components/NewEventDialog";
import { organiserQueries } from "../features/organisers/api/queries";
import { tagQueries } from "../features/tags/api/queries";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute("/_authenticated/events/new")({
  /*
   * The tag checkboxes, venue picker and organiser checkboxes all need their
   * options before first paint — and the organisers especially, since the
   * location prefill reads their defaults the moment one is ticked.
   */
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(tagQueries.list()),
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(organiserQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]),
  component: NewEventPage,
});

/**
 * The route is the dialog's open state, so this is just the chrome behind it.
 *
 * The header stays rendered rather than being covered by a full-bleed page,
 * because the modal is deliberately reachable by URL: arriving at /events/new
 * directly should still look like the app, not like a form floating on nothing.
 */
function NewEventPage() {
  return (
    <>
      <AppHeader />
      <NewEventDialog closeTo="/events" />
    </>
  );
}
